import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Icon, Input } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const ListContacts = function ({ match, history }) {
  // Settings form
  const [formatedData, setFormatedData] = useState([])
  const [formValues, setFormValues] = useState({})
  const { count, page, pageSize } = formatedData
  // Created component
  useEffect(() => {
    listContacts(formValues)

    return () => {
      setFormValues({})
      setFormatedData({})
    }
  }, [])

  // Api requests
  async function listContacts(params) {
    try {
      const response = await request(api.listContacts(params))
      console.tron.log('response listContacts', response)
      const itens = response.items
      const formatedRows = []
      itens.map((item) => {
        return formatedRows.push({
          key: item.id,
          ...item,
          actions: formatActions(item.id)
        })
      })
      setFormatedData({
        ...response,
        items: formatedRows,
        actions: 'teste'
      })
    } catch (error) {
      console.tron.log(error)
    }
  }

  // Formaters
  const columns = [
    {
      title: getMessage('contactsContactName'),
      dataIndex: 'contactName'
    },

    {
      title: getMessage('contactsJobRole'),
      dataIndex: 'jobRole'
    },

    {
      title: getMessage('contactsEmail'),
      dataIndex: 'email'
    },

    {
      title: getMessage('contactsPhoneNumber'),
      dataIndex: 'phoneNumber'
    },

    {
      title: 'Visitas',
      dataIndex: 'actions'
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    listContacts({
      page: current - 1,
      ...formValues
    })
  }

  const formatActionsContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/contacts/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )
  function formatActions(id) {
    return formatActionsContent(id)
  }

  const canCreate = validRule(RULES.CUSTOMER_CONTACT)

  return (
    <>
      <div style={{ paddingBottom: '0.5rem' }}>
        <div>
          <Typography.Title level={3} style={{ margin: '0 0 0 0' }}>
            {' '}
            {getMessage('listContacts')}{' '}
          </Typography.Title>
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <CustomBreadcrumb match={match} history={history} />

          {canCreate === true && (
            <Button className="bgPrimary" type="primary" onClick={() => history.push('/contacts/create')}>
              {getMessage('storeContacts')}
            </Button>
          )}
        </div>
      </div>

      <Card className="ant-card gx-card ant-card-bordered">
        <Input.Search
          onSearch={(value) =>
            listContacts({
              search: value
            })
          }
          placeholder={getMessage('search')}
          className="default-header-search"
        />
        <Table
          key="id"
          columns={columns}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListContacts
